import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=7f198fa8&scoped=true&"
import script from "./tab.vue?vue&type=script&lang=ts&"
export * from "./tab.vue?vue&type=script&lang=ts&"
import style0 from "./tab.vue?vue&type=style&index=0&id=7f198fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f198fa8",
  null
  
)

export default component.exports